/**
 * UK Date formatting utilities
 * Formats dates in UK style: "Friday 12th December"
 */

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

/**
 * Get ordinal suffix for a day number (1st, 2nd, 3rd, 4th, etc.)
 */
function getOrdinalSuffix(day: number): string {
  if (day > 3 && day < 21) return 'th'
  switch (day % 10) {
    case 1: return 'st'
    case 2: return 'nd'
    case 3: return 'rd'
    default: return 'th'
  }
}

/**
 * Format an ISO date string (YYYY-MM-DD) to UK format: "Friday 12th December"
 */
export function formatDateUK(isoDate: string): string {
  if (!isoDate) return ''

  const date = new Date(isoDate + 'T00:00:00')
  if (isNaN(date.getTime())) return ''

  const dayName = DAYS[date.getDay()]
  const dayNum = date.getDate()
  const monthName = MONTHS[date.getMonth()]
  const suffix = getOrdinalSuffix(dayNum)

  return `${dayName} ${dayNum}${suffix} ${monthName}`
}

/**
 * Format an ISO date string for HTML input[type="date"] (YYYY-MM-DD)
 */
export function formatDateForInput(isoDate: string): string {
  if (!isoDate) return ''
  // Already in ISO format, just return it
  return isoDate.split('T')[0]
}

/**
 * Parse a date input value (YYYY-MM-DD) to ISO date string
 */
export function parseDateFromInput(inputValue: string): string {
  if (!inputValue) return ''
  // Input already gives us YYYY-MM-DD format
  return inputValue
}

/**
 * Add days to an ISO date string and return new ISO date string
 */
export function addDays(isoDate: string, days: number): string {
  if (!isoDate) return ''

  const date = new Date(isoDate + 'T00:00:00')
  date.setDate(date.getDate() + days)

  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
